"use strict";
/// <reference path="../../../global.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
var HSBasePlugin = /** @class */ (function () {
    function HSBasePlugin(el, options, events) {
        this.el = el;
        this.options = options;
        this.events = events;
        this.el = el;
        this.options = options;
        this.events = {};
    }
    HSBasePlugin.prototype.createCollection = function (collection, element) {
        var _a;
        collection.push({
            id: ((_a = element === null || element === void 0 ? void 0 : element.el) === null || _a === void 0 ? void 0 : _a.id) || collection.length + 1,
            element: element,
        });
    };
    HSBasePlugin.prototype.fireEvent = function (evt, payload) {
        if (payload === void 0) { payload = null; }
        if (this.events.hasOwnProperty(evt))
            return this.events[evt](payload);
    };
    HSBasePlugin.prototype.on = function (evt, cb) {
        this.events[evt] = cb;
    };
    return HSBasePlugin;
}());
exports.default = HSBasePlugin;
